import { Mutation } from 'vuex';
import { IModuleState } from './types';

// 短信验证码
export const setSmsState: Mutation<IModuleState> = (state, payload) => {
  state.smsState.success = payload.success;
  state.smsState.loading = !!payload.loading;
};

export const setLoading: Mutation<IModuleState> = (state, payload) => {
  state.loading = payload;
};
